import { Chip, ChipProps, Stack } from "@mui/material";
import {
  OrganisationMembershipInvitationStatus,
  OrganisationMembershipStatus,
} from "../../../clients/graphqlTypes.js";
import { assertNever } from "../../utils.js";
import { useTranslate } from "@tolgee/react";
import { useOrganisationMembershipStatuses } from "./useOrganisationMembershipStatuses.js";

interface Props {
  membershipStatus: OrganisationMembershipStatus;
  invitation: {
    id: string;
    status: OrganisationMembershipInvitationStatus;
  } | null;
  wrap?: boolean;
}

export const OrganisationMembershipStatusLabel = ({
  membershipStatus,
  invitation,
  wrap,
}: Props) => {
  const { t } = useTranslate(["OrganisationInvite"]);
  const { statusLabels } = useOrganisationMembershipStatuses();

  return (
    <Stack direction="row" spacing={0.5} flexWrap={wrap ? "wrap" : "nowrap"}>
      <Chip
        label={statusLabels[membershipStatus]}
        size="small"
        variant="filled"
        sx={{
          textTransform: "uppercase",
        }}
        color={
          membershipStatus === "ACTIVATED"
            ? "success"
            : membershipStatus === "DEACTIVATED"
              ? ("black" as ChipProps["color"])
              : membershipStatus === "UNACTIVATED"
                ? "default"
                : assertNever(membershipStatus)
        }
      />
      {membershipStatus === "UNACTIVATED" && invitation && (
        <Chip
          label={
            invitation.status === "PENDING"
              ? t("Invitation pending", { ns: "OrganisationInvite" })
              : invitation.status === "DECLINED"
                ? t("Invitation declined", { ns: "OrganisationInvite" })
                : invitation.status === "ACCEPTED"
                  ? t("Invitation accepted", { ns: "OrganisationInvite" })
                  : assertNever(invitation.status)
          }
          size="small"
          variant="filled"
          color={
            invitation.status === "ACCEPTED"
              ? "success"
              : invitation.status === "DECLINED"
                ? "error"
                : invitation.status === "PENDING"
                  ? "warning"
                  : assertNever(invitation.status)
          }
          sx={{
            textTransform: "uppercase",
          }}
        />
      )}
    </Stack>
  );
};
